export default __webpack_public_path__ + "static/media/check-icon.50e1b469.svg";